import * as GameCommands from "../../core/src/commands/GameCommands";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import { UIButtons } from "../../core/src/ui/UIButtons";
import SwitchButton from "../../core/src/views/components/SwitchButton";
import UIController from "../../core/src/ui/UIController";
import SoundController from "../../core/src/utils/SoundController";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import BangUp from "../../core/src/utils/BangUp";
import { Ease } from "../../core/src/Ease";
import GameModel from "../../core/src/model/GameModel";
import BetModel from "../../core/src/model/BetModel";
import JackpotsModel from "../model/JackpotsModel";
import VendorWrapper from "../controllers/VendorWrapper";
import IJackpotData from "../server/data/IJackpotData";
import SoundVars from "../../core/src/const/SoundVars";
import App from "../../core/src/App";
import VendorModel from "../model/VendorModel";
import FConnector from "../server/FConnector";
import LocalData from "../../core/src/utils/LocalData";
import LocalStorageVars from "../../core/src/const/LocalStorageVars";


export async function SetBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    BetModel.setStake(betData.multiplier, betData.coinIndex);
    GameCommands.UpdateBetCommand();
    LocalData.saveObject(LocalStorageVars.LAST_BET, betData);

    await FConnector.setActiveBet(betData.value);
  }

export function ToggleBetPopupCommand() {
    GameCommands.ToggleBetPopupCommand();
}

export function ToggleGamePauseCommand(pause: boolean) {
    if(App.instance.paused != pause) {
        App.instance.paused = pause;
    }
}

export function ToggleAutoplayPopupCommand() {
    GameCommands.ToggleAutoplayPopupCommand();
}

export function ToggleTuboSpinCommand() {
    GameCommands.ToggleTuboSpinCommand();
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get("turbo") as SwitchButton;
    btn.toggle();
    SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleSettingsCommand() {
    UIController.toggleComponent("settings", "paytable");
}

export function ToggleSoundPopupCommand() {
    UIController.toggleComponent("soundPopup");
    let btn1 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn1.toggle();
    let btn2 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.SoundMuted) as SwitchButton;
    btn2.toggle();
}
export function ToggleSoundButtonCommand(param?: any) {
    let btn1 = ViewManager.getLayer(DefaultLayers.BetBarBottom)
        .setScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn1.visible = SoundController.isSoundEnabled;
    let btn2 = ViewManager.getLayer(DefaultLayers.BetBarBottom)
        .setScene()
        .buttons.get(UIButtons.SoundMuted) as SwitchButton;
    btn2.visible = !SoundController.isSoundEnabled;

    //TODO SAVE SETTINGS
    // if (param == "uiSoundBtn") {
    //     GameCommands.SaveSettingsCommand();
    // }
}

export const ToggleMasterSoundBtn = (enabled?: boolean) => {
    SoundController.toggleMasterSound(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
};

export const ToggleSoundFXCommand = (enabled?: boolean) => {
    SoundController.toggleEffects(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
};

export const ToggleMusicCommand = (enabled?: boolean) => {
    SoundController.toggleMusic(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
};

export function UpdateJackpotsCommand() {
    if (GameModel.gameConfig.hasJackpotsFeature && JackpotsModel.jackpotsAvailable) {
        CommManager.send(
            RequestRegister.get("jackpotsUpdate"),
            async function (data: any) {
                VendorWrapper.setJackpotValues(data.data as IJackpotData[]);
            },
            this
        );
    }
}
export function ToggleJackpotBtnCommand(state: boolean) {
    let btn: SwitchButton = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get("jackpot") as SwitchButton;
    btn && btn.switch(state);
}

export function ShowInsufficientFoundsDialog(callback) {
    UIController.toggleComponent("insufficientFundsPopup", callback);
}

export async function GoHome() {
    FConnector?.exit();
    if (GameModel.homeUrl) {
        if (GameModel.homeUrl === "close") {
            window.close();
        } else {
            document.location.assign(GameModel.homeUrl);
        }
    } else {
        window.history.back();
    }
}

export function ToggleHomeBtnCommand() {
    if (GameModel.homeUrl) {

    } else {
        const scene = ViewManager.getLayer(DefaultLayers.MenuUI)?.getCurrentScene();
        const homeBtn  = scene?.buttons?.get(UIButtons.Home);
        homeBtn?.setVisible(false);
    };
}

export function showHistory() {
    GameModel.isReplay = true;
    FConnector.openHistory();
}
